import React, { useEffect, useState } from "react"
import Select from "react-select"
import { Controller } from "react-hook-form"
import { getCreditPeriod } from "../../../services/Settings/dropdown"

function ucfirst(str) {
  var firstLetter = str.substr(0, 1)
  return firstLetter.toUpperCase() + str.substr(1)
}

const CreditPeriod = ({
  control,
  name,
  onSelectChange,
  target,
  placeholder,
  disable,
}) => {
  const [isLoading, setIsLoading] = useState(true)
  const [fetchResponse, setFetchResponse] = useState([])

  const loadOptions = async () => {
    const data = await getCreditPeriod()
    setIsLoading(false)
    const response = Object.values(data?.data || {})?.map(dta => {
      return {
        label: dta?.label && ucfirst(dta.label),
        value: dta.id,
        ...dta,
      }
    })

    setFetchResponse(response)
  }
  useEffect(() => {
    loadOptions()
  }, [])

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({
          field: { onChange, ref, value },
          fieldState: { invalid },
        }) => {
          return (
            <Select
              options={fetchResponse}
              // placeholder={placeholder ? placeholder : "Select"}
              placeholder={
              <div className="css-placeholder">
                {placeholder || "Select"} 
              </div>
            }
              isLoading={isLoading}
              inputRef={ref}
              invalid={invalid}
              onChange={e => {
                onChange(e)
                if (onSelectChange) onSelectChange(e)
              }}
              isDisabled={disable ? true : false}
              value={value}
              classNamePrefix="react-select"
              className="elevate-dropdown"
              // menuPortalTarget={document.querySelector(
              //   target ? target : ".modal"
              // )}
              menuPortalTarget={document.body} // Ensure the dropdown renders correctly within the modal
              styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
            />
          )
        }}
      />
    </div>
  )
}

export default CreditPeriod
